import React, { useState } from "react";

import { BasicCompanyContact, ContactProfileSimilarFragmentParameter } from "@/app/pages/contactProfile/contactDirectory/interface";
import HooversModal from "@/app/pages/contactProfile/HooversModal";
import Paper from "@/app/pages/contactProfile/Paper";
import { createContactProfileUrl } from "@/app/pages/contactProfile/ContactProfileColleagues";
import "@/app/pages/contactProfile/styles/ContactProfileSimilarStyles.scss";

interface SimilarContactData {
	"contactClass": string;
	"contacts": BasicCompanyContact[];
	"title": string;
	"viewAllClassName": string;
}

type ContactProfileSimilarFragmentComponentProps = ContactProfileSimilarFragmentParameter;

const SimilarContacts = (props: ContactProfileSimilarFragmentComponentProps): JSX.Element => {
	const { contactSimilarContactsData } = props;

	const {
		similarIndustryAndLocationContacts,
		similarTitleAndIndustryContacts,
		similarTitleAndLocationContacts
	} = contactSimilarContactsData;

	const [showModal, setShowModal] = useState(false);

	const onClickModalButton = (type: "close" | "open") => setShowModal(type === "open");

	const similarContactDataRenderer = (similarContactData: SimilarContactData) => {
		const {
			contactClass,
			contacts,
			title,
			viewAllClassName
		} = similarContactData;

		return (
			<div className="col-md-4 inner-container">
				<div className="container-title">
					{title}
				</div>

				{
					contacts.length > 0
						?
						<>
							<ul>
								{
									contacts.map((co, nu) => {
										const {
											basicContact,
											companyName
										} = co;

										const {
											familyName,
											givenName,
											url
										} = basicContact;

										const basicContactTitle = basicContact.title;

										return (
											<li key={nu}>
												<div>
													<a
														className="name-text"
														href={createContactProfileUrl(url)}>
														{givenName} {familyName}
													</a>

													<p className="details-text">
														{basicContactTitle}

														{" "}

														at

														{" "}

														{companyName}
													</p>
												</div>
											</li>
										);
									})
								}
							</ul>

							<div className="view-more-wrapper">
								<a
									className={`viewAllLink suppress-ms-ext-icon anchor ${viewAllClassName}`}
									onClick={() => onClickModalButton("open")}>
									View All
									{" "}

									<span className="ContactProfileSimilarFragmentComponentViewAllLink right-arrow" />
								</a>

								<HooversModal
									onClickModalButton={onClickModalButton}
									showModal={showModal} />
							</div>
						</>
						:
						<div>
							<p className="no-match-text">
								No Contact Match Found
							</p>
						</div>
				}
			</div>
		);
	};

	return (
		<Paper
			title="Get in Touch with Similar Contacts"
			blockId="similar-contacts-block"
			onClickModalButton={onClickModalButton}
			showModal={showModal}
		>

			<div className="row similar-contacts-flex-wrap">
				{
					similarContactDataRenderer(
						{
							"contactClass": "same-industry-contact",
							"contacts": similarTitleAndIndustryContacts,
							"title": "People with Similar Job Titles in the Same Industry",
							"viewAllClassName": "view-all-same-industry"
						}
					)
				}

				{
					similarContactDataRenderer(
						{
							"contactClass": "same-location-contact",
							"contacts": similarTitleAndLocationContacts,
							"title": "People with Similar Job Titles in the Same Location",
							"viewAllClassName": "view-all-same-location"
						}
					)
				}

				{
					similarContactDataRenderer(
						{
							"contactClass": "same-industry-location-contact",
							"contacts": similarIndustryAndLocationContacts,
							"title": "People in the Same Industry and Location",
							"viewAllClassName": "view-all-same-industry-location"
						}
					)
				}
			</div>

			<div className="hidden-md hidden-lg swipe-text">
				Swipe to view more
			</div>
		</Paper>
	);
};

export default SimilarContacts;
